// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__Zu0CG","AvatarAgent":"Avatar_AvatarAgent__mePp4"};